import { useEffect, useState } from "react";
import { memberApi } from "../../lib/member";

// Owner-only portrait fetched with the auth header (never a public URL); falls back to script initials.
export function MemberAvatar({ profile, size = 56, testid = "member-avatar", srcOverride, loader = memberApi.photoBlob, alt = "Your profile photo" }) {
  const [src, setSrc] = useState(null);
  const version = profile?.has_photo ? profile.photo_version : null;

  useEffect(() => {
    if (!version || srcOverride) { setSrc(null); return undefined; }
    let url = null, cancelled = false;
    loader()
      .then(b => { if (!cancelled) { url = URL.createObjectURL(b); setSrc(url); } })
      .catch(() => setSrc(null));
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [version, srcOverride]); // eslint-disable-line react-hooks/exhaustive-deps

  const shown = srcOverride || src;
  return (
    <span className="fs-avatar" style={{ width: size, height: size, fontSize: size * 0.5 }} data-testid={testid}>
      {shown
        ? <img src={shown} alt={alt} data-testid={`${testid}-photo`} />
        : <span aria-label={`Initials ${profile?.initials || ""}`} style={{ paddingTop: size * 0.08 }} data-testid={`${testid}-initials`}>{profile?.initials || ""}</span>}
    </span>
  );
}
